import React from 'react';
import { Link } from 'react-router-dom';
import CustomNavbar from '../Components/Navbar';
import Footer from '../Components/Footer';

function PageNotFound() {
    return (
        <div className='d-flex justify-content-center align-items-center'
            style={{ height: "68vh", width: "100%" }}>
            <CustomNavbar/>
            <div className="text-center" style={{ margin:'10rem auto'}}>
                <h1 className="text-danger display-1 mt-5 fw">Page Not Found 404</h1>
                <h4 className="lead fw-bold">Sorry, this page was not found.</h4>
                <h4 className="lead fw-bold">You can go back to <Link className="text-primary" to="/">Home</Link>.</h4>
            </div>
            <Footer/>
        </div>
    );
}

export default PageNotFound;